import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useMembersPageActions, useMembersPageSelector} from '../../../hooks/runtime'
import {EventLink} from '../../styled-components/event-link'
import {DetailsButtonProps} from './interfaces'

export const DetailsButton = ({event}: DetailsButtonProps) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const mobile = useMembersPageSelector(isMobile)

  const {navigateToDetailsPage, navigateToDetailsPageOld} = useMembersPageActions()

  const handleClick = () =>
    experiments.enabled(ExperimentNames.UseEventsViewerReduxToolkit)
      ? navigateToDetailsPage({event})
      : navigateToDetailsPageOld(event)

  return (
    <EventLink
      primary
      mobile={mobile}
      as="a"
      onKeyPress={handleKeyPressEnterOrSpace(handleClick)}
      onClick={handleClick}
      data-hook={DH.BUTTON_GO_TO_DETAILS}
    >
      {t('events.buttons.go-to-details')}
    </EventLink>
  )
}
